import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { useInvoiceDetails } from "../data/invoice";

export default function InvoicePdf() {
  const { t } = useTranslation();
  const { invoiceId } = useParams<{ invoiceId: string }>();

  const { data, isLoading, isError } = useInvoiceDetails(invoiceId);

  // Redirect to PDF when data is loaded
  useEffect(() => {
    if (data?.invoice.invoicePdf) {
      window.location.href = data.invoice.invoicePdf;
    }
  }, [data]);

  // Derive error message
  const getErrorMessage = () => {
    if (!invoiceId) return t("gymkeePay.invoice.idMissing");
    if (data && !data.invoice.invoicePdf) {
      return t("gymkeePay.invoicePdf.pdfNotAvailable");
    }
    if (isError) {
      return t("gymkeePay.invoice.failedToLoad");
    }
    return null;
  };

  const errorMessage = getErrorMessage();

  if (errorMessage && !isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="mb-4 text-6xl">📄</div>
          <h1 className="mb-2 text-xl font-semibold text-gray-900">
            {t("gymkeePay.invoicePdf.errorTitle")}
          </h1>
          <p className="text-gray-600">{errorMessage}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="mb-4">
          <svg
            className="mx-auto h-12 w-12 animate-spin text-gray-400"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        </div>
        <p className="text-gray-600">{t("gymkeePay.invoicePdf.loading")}</p>
      </div>
    </div>
  );
}
